const content = store => store.productClass || {};
export const getProductClass = store => content(store).productClass;
export const getAllProductClasses = store => content(store).productClasses;
export const isLoaded = store => !!content(store).isLoaded;
